import MangaPage from '../../src/pages-components/MangaPage/MangaPage';
import ControlPanel from '../../src/components/ControlPanel/ControlPanel';
import Head from 'next/head';

export default function Manga({ mangaData, chaptersData, error, currentUrl }) {
  const coverImage = mangaData?.cover_url || '/logo/og-default.jpg';
  const pageTitle = mangaData
    ? `${mangaData.title}${mangaData.alternative_titles?.[0] ? ` (${mangaData.alternative_titles[0]})` : ''} | ManGO`
    : error
      ? 'Ошибка загрузки | ManGO'
      : 'Манга не найдена | ManGO';
  const pageDescription = mangaData?.description || (error ? 'Не удалось загрузить информацию о манге' : 'Запрошенная манга не найдена');

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:type" content="book" />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={coverImage} />
        <meta property="og:site_name" content="ManGO" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={currentUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={coverImage} />

        <link rel="canonical" href={currentUrl} />
      </Head>

      <MangaPage mangaData={mangaData} chaptersData={chaptersData} />
      <ControlPanel />
    </>
  );
}

export async function getServerSideProps(context) {
  const { id } = context.params;
  const currentUrl = `https://${context.req.headers.host}${context.req.url}`;

  const serverLogger = (await import('../../logger/serverLogger')).default;

  if (!id) {
    serverLogger.warn(`[SSR][Manga] ID не указан. URL=${currentUrl}`);
    return {
      props: {
        mangaData: null,
        chaptersData: null,
        error: 'ID не указан',
        currentUrl,
      },
    };
  }

  try {
    serverLogger.info(`[SSR][Manga] Запрос: ${currentUrl}, Название: ${id}`);
    const baseUrl = process.env.API_URL || 'http://mango-read.org';

    // Получаем мангу
    const mangaResponse = await fetch(`${baseUrl}/api/v1/project/${id}`);
    if (!mangaResponse.ok) {
      serverLogger.error(`[SSR][Manga] Манга не найдена. Название: ${id}, status=${mangaResponse.status}`);
      return { props: { mangaData: null, chaptersData: [], error: 'Манга не найдена', currentUrl } };
    }

    const manga = await mangaResponse.json();
    serverLogger.info(`[SSR][Manga] Манга загружена: ${manga.id} - ${manga.title}`);

    // Получаем главы
    const project_id = manga.id;
    const chaptersResponse = await fetch(`${baseUrl}/api/v1/chapters?project_id=${project_id}`);
    const chaptersData = chaptersResponse.ok ? await chaptersResponse.json() : [];
    serverLogger.info(`[SSR][Manga] Глав загружено: ${chaptersData.length} для Манги: ${manga.title}`);

    const mangaData = {
      ...manga,
      rate: manga.avg_rating?.toFixed(1) || '0',
      transliterated_name: id,
      project_id: manga.id,
      chapter: manga.chapter_count,
      tag: `${manga.type} ${manga.release_year}`,
      votes: manga.total_likes,
      cover_url: manga.cover_url, // важно для соцсетей
    };

    return {
      props: {
        mangaData,
        chaptersData,
        error: null,
        currentUrl,
      },
    };
  } catch (err) {
    serverLogger.error(`[SSR][Manga] Ошибка загрузки: ${err.message}`, { stack: err.stack });
    return {
      props: {
        mangaData: null,
        chaptersData: null,
        error: 'Ошибка загрузки данных',
        currentUrl,
      },
    };
  }
}
